// Prix payé dans la devise réellement choisie. La devise principale ignore toujours
// les anciens overrides prices[devise], même si son code arrive en majuscules.
export function getProductPrice(product,devise,principalDevise,rate,type=null){
    const dev=(devise||"").toLowerCase()
    if(!dev || dev===(principalDevise||"").toLowerCase()){
        return product?.montant || 0
    }
    const override=product?.prices?.[dev]
    if(type!=="VIRTUAL" && override!==undefined && override!==null && override!=="" && !isNaN(Number(override))){
        return Number(override)
    }
    return Math.round((Number(product?.montant)||0)*(Number(rate)||1)*100)/100
}
